<template>
  <div class="example py-md">
    <div class="session-line" v-if="false">
      <div class="line"></div>
      <div class="text">历史会话</div>
      <div class="line"></div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClickTab" type="border-card">
      <el-tab-pane v-for="i in tabList" :label="i.label" :name="i.name" :key="i.name">
        <tabContent :activeName="activeName" :quesNum="quesNum" :isRandom="isRandom" :treeList="treeList" :guessList="guessList" :classifyId="classifyId" :classifyName="classifyName" @handleSendMessage="handleSendMessage"></tabContent>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import tabContent from './tabContent.vue'
export default {
    components: {
      tabContent
    },
    props: {
      talkIndex: {
        type: Number
      }
    },
    data() {
      return {
        classifyId: "",
        classifyName: "",
        treeList: [],
        correlationData: [],
        guessList: [],
        tabList: [
          {label: '个人业务', name: '1'},
          {label: '单位业务', name: '2'}
        ],
        activeName: '1',
        isRandom: false,
        quesNum: 0,
      };
    },
    computed: {},
    watch: {},
    methods: {
      changeGuess() {
        // this.getGuessList(this.id,this.activeName)
      },
      // 获取当前主题下的推荐问题
      getGuessList(id, activeName) {
        // 以前的接口
        // this.$axios.get("/conversation/list/recommend").then((res) => {
        this.$axios.get("/conversation/list/flow", {
          classifyId: id,
          questionCustomer: activeName
        }).then((res) => {
          console.log('随机三条数据', res)
          this.guessList = res.content.slice(0, 3);
          this.quesNum = res.content.length;
        }).catch((err) => {

        });
      },
      // 获取随机状态
      getRandom() {
          this.$axios.get("/manage/system/random/status").then((res) => {
            this.isRandom = res.content;
          }).catch((err) => {
          });
      },
      handleSendMessage(e) {
        console.log('点击常见情景收到的item', e)
        
        this.$emit("send", e, this.talkIndex);
      },
      handleClick(e) {
        this.classifyId = e.id;
        this.classifyName = e.classifyName;
        // this.getGuessList(e.id)
        this.$store.commit('SET_ARR', [])
      },
      // 获取主题分类
      getThemeList(activeName) {
        this.$axios.get("/conversation/list/classify",{
          questionCustomer: activeName
        }).then((res) => {
          console.log('主题列表', res)
          this.treeList = res.content.slice(0, 5);
          this.classifyId = this.treeList[0].id;
          this.classifyName = this.treeList[0].classifyName;
          this.getGuessList(this.classifyId, this.activeName)
        });
      },
      // tab切换
      handleClickTab(tab, e) {
        this.$emit("sendTabId", tab.name);
        this.activeName = tab.name;
        this.getThemeList(this.activeName)
      }
    },
    created() {
      this.getThemeList(this.activeName)
      this.getRandom()
    },
    mounted() {
      
    },
  };
</script>
<style lang="scss" scoped>

// tab
::v-deep .el-tabs--border-card {
  border: none;
  box-shadow: none;
  border-radius: 4px;
  margin: 0 10px;
  .el-tabs__header{
    border-bottom: 1px solid #eeecec;
    .el-tabs__item{
      color: #303133;
    }
    .el-tabs__item.is-active{
      border-top-left-radius: 4px;
      color: #3b62f1;
      border-right-color: #eeecec;
      border-left-color: #eeecec;
    }
    .el-tabs__item:not(.is-disabled):hover{
      color: #3b62f1;
    }
  }
  .el-tabs__nav-wrap{
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

  }
  
}
  .session-line {
    display: flex;
    align-items: center;

    .text {
      font-size: 14px;
      margin: 0 10px;
      color: #999;
    }

    .line {
      border-top: 1px dashed #999;
      flex: 1;
    }
  }

  // 之前的代码
  .example {
    .ques-list {
      background-color: #fff;
      padding: 6px;
      border-radius: 6px;

      .ques-item {
        line-height: 30px;
        font-size: 14px;
        color: #3d7eff;
      }
    }

    ul {
      margin-bottom: 10px;
      // margin: 0 10px 10px;
      list-style-type: none;
    }

    .themeList {
      display: flex;
      justify-content: space-between;
    }

    .tree-item {
      font-size: 12px;
      // background-color: #fff;
      background-color: #f5f6f8;
      padding: 6px;
      border-radius: 6px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 15%;

      .icon {
        margin-bottom: 6px;
        height: 24px;
        width: 24px;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #3d7eff19 !important;

        i {
          font-size: 14px;
          color: #3d7eff;
        }
      }

      .text {
        white-space: nowrap;
        color: black;
      }
    }

    .active {
      background-color: #3b62f1;
      color: #fff;

      .text {
        color: #fff;
      }

      .icon {
        background-color: #fff !important;
      }
    }
  }

  .guessAsk {
    background: #f5f6f8;
    border-radius: 4px;
    box-shadow: 0 0 5px #f5f6f8;
    padding: 15px;
    box-sizing: border-box;
    // margin: 0 10px;
    font-size: 14px;

    .changeGuess {
      display: flex;
      justify-content: space-between;

      p {
        &:nth-of-type(1) {
          font-weight: bold;
        }

        &:nth-of-type(2) {
          color: #3b62f1;
        }
      }
    }

    .guessList {
      margin: 10px 0 0;
    }

    .guessList li {
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeecec;

      .text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80%;
      }

      &:last-child {
        border: none;
      }
    }
  }
</style>